import { render, staticRenderFns } from "./board-slot.vue?vue&type=template&id=b51d192e&"
import script from "./board-slot.vue?vue&type=script&lang=js&"
export * from "./board-slot.vue?vue&type=script&lang=js&"
import style0 from "./board-slot.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports